import {
    GET_COUNTRY_FAILURE,
    GET_COUNTRY_REQUEST,
    GET_COUNTRY_SUCCESS,
    GET_STATE_FAILURE,
    GET_STATE_REQUEST,
    GET_STATE_SUCCESS,
    GET_CITY_FAILURE,
    GET_CITY_REQUEST,
    GET_CITY_SUCCESS,
  } from "./customerAddressTypes";
  
  // Country Actions
  export const customerCountryRequest = () => ({
    type: GET_COUNTRY_REQUEST,
  });
  
  export const customerCountrySuccess = (data) => ({
    type: GET_COUNTRY_SUCCESS,
    payload: data,
  });
  
  export const customerCountryFailure = (error) => ({
    type: GET_COUNTRY_FAILURE,
    payload: error,
  });
  
  // State Actions
  export const customerStateRequest = (data) => ({
    type: GET_STATE_REQUEST,
    payload: data,
  });
  
  export const customerStateSuccess = (data) => ({
    type: GET_STATE_SUCCESS,
    payload: data,
  });
  
  export const customerStateFailure = (error) => ({
    type: GET_STATE_FAILURE,
    payload: error,
  });
  
  // City Actions
  export const customerCityRequest = (data) => ({
    type: GET_CITY_REQUEST,
    payload: data,
  });
  
  export const customerCitySuccess = (data) => ({
    type: GET_CITY_SUCCESS,
    payload: data,
  });
  
  export const customerCityFailure = (error) => ({
    type: GET_CITY_FAILURE,
    payload: error,
  });
  
